var Page = (function ($, document) {
    'use strict';

    var
        animationTimeout = 120,
        $mainPageTitle = $('#main-page-title-header'),
        $mainPageSubTitle = $mainPageTitle.next('.lead'),
        $wholePageLoader = $('#whole-page-loader'),
        metaTitle = document.title,
        metaTitlePrefix = '';

    function replaceContent($placeholder, content) {
        return $placeholder.fadeOut(animationTimeout).promise().pipe(function() {
            return $placeholder.empty().html(content).fadeIn(animationTimeout);
        });
    }

    return {
        preload: function () {
            $wholePageLoader.removeClass('hidden');
        },

        finishLoad: function() {
            $wholePageLoader.addClass('hidden');
            $(document).trigger('products-updated');

            $('img', '.title-icon').removeAttr('alt');
        },

        setContent: function (placeholder, content, constantSelectors) {
            var
                $placeholder = $(placeholder),
                $constants = $placeholder.find( constantSelectors.join(',') );

            if($constants.length === 0) {
                $.when(replaceContent($placeholder, content)).done(this.finishLoad);
            }
            else {
                $placeholder.html(content);
                this.finishLoad();
            }
        },

        setMetaTitlePrefix: function(_metaTitlePrefix) {
            metaTitlePrefix = _metaTitlePrefix;
        },

        setMetaTitle: function(_metaTitle) {
            metaTitle = _metaTitle;
            document.title = metaTitlePrefix + _metaTitle;
        },

        refreshMetaTitle: function() {
            document.title = metaTitlePrefix + metaTitle;
        },

        setTitle: function(title) {
            $mainPageTitle.text(title);
        },

        setSubTitle: function(subTitle) {
            $mainPageSubTitle.html(subTitle);
        },

        setAjaxPage: function(object) {
            if(object.metaTitle) {
                this.setMetaTitle(object.metaTitle);
            }
            if(object.title) {
                this.setTitle(object.title);
            }
            if(object.subTitle) {
                this.setSubTitle(object.subTitle);
            }

            this.setContent(object.placeholder, object.view, object.constantSelectors);
        }
    };
})(jQuery, document);
